import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./lib/auth";
import { initializeAnalytics } from "./lib/analytics";
import "@fontsource-variable/manrope";
import "./styles.css";

const savedTheme = localStorage.getItem("kbg-theme");
document.documentElement.dataset.theme = savedTheme ?? (matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
initializeAnalytics();

const root = document.getElementById("root")!;
root.replaceChildren();
createRoot(root).render(
  <StrictMode><AuthProvider><App /></AuthProvider></StrictMode>,
);
